import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RRContrastColor } from '../../../common/helpers/contrast-color.helpers';
import { RRITag } from '../../interfaces/tag.interface';

@Component({
  selector: 'rr-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
})
export class TagComponent<T extends RRITag> {
  @Input() tag: T;
  @Input() hasClickAction: boolean;
  @Input() showRemoveButton: boolean;
  @Output() tagClicked: EventEmitter<T> = new EventEmitter<T>();
  @Output() removeClicked: EventEmitter<T> = new EventEmitter<T>();

  constructor() {}

  public getTextColor(): string {
    return this.tag.color ? `${RRContrastColor(this.tag.color)}` : undefined;
  }

  public getTagText(): string {
    if (this.tag.format) {
      return this.tag.format(this.tag);
    }

    return this.tag.name;
  }

  public onTagClicked(): void {
    if (this.hasClickAction && this.tagClicked) {
      this.tagClicked.emit(this.tag);
    }
  }

  public onRemoveTagClicked(): void {
    if (this.showRemoveButton && this.removeClicked) {
      this.removeClicked.emit(this.tag);
    }
  }
}
